var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 293,
    viewBox: "0 0 293 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.036 0H91.3742C40.911 0 0 40.911 0 91.3742V201.036C0 251.499 40.911 292.41 91.3742 292.41H201.036C251.499 292.41 292.423 251.499 292.423 201.036V91.3742C292.423 40.911 251.499 0 201.036 0ZM182.761 201.036C182.761 221.221 166.397 237.585 146.211 237.585H109.662V182.761C109.662 162.576 126.026 146.211 146.211 146.211H182.761V201.036ZM237.585 91.3742C237.585 111.559 221.221 127.924 201.036 127.924H54.8245V91.3742C54.8245 71.1889 71.1889 54.8245 91.3868 54.8245H237.585V91.3742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.27249951441ab337c8927b4d69f74f59.svg";
export { ForwardRef as ReactComponent };